import { assignInlineVars } from "@vanilla-extract/dynamic";
import { useTranslation } from "react-i18next";
import {
  progressBar,
  progressBarContainer,
  progressBarFill,
  progressBarLabel,
  progressWidth,
} from "../teamBuilder.css";

interface TeamBuilderProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const TeamBuilderProgressBar = ({
  currentStep,
  totalSteps,
}: TeamBuilderProgressBarProps) => {
  const { t } = useTranslation("onboarding");

  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className={progressBarContainer}>
      <div
        className={progressBar}
        role="progressbar"
        aria-label={t("progressBar.ariaLabel", "Team Selection Progress")}
        aria-valuenow={Number(progressPercentage.toFixed(0))}
      >
        <div
          className={progressBarFill}
          style={assignInlineVars({
            [progressWidth]: `${progressPercentage}%`,
          })}
        />
      </div>
      <span className={progressBarLabel}>
        {t(
          "progressBar.label",
          "Step {{currentTutorialStep}} of {{tutorialStepCount}}",
          { currentTutorialStep: currentStep, tutorialStepCount: totalSteps },
        )}
      </span>
    </div>
  );
};

export default TeamBuilderProgressBar;
